import React, { useState } from 'react'
import { Button } from '../../../ui/button'
import RadioButtonList from '../../../ui/radioButton'
import { Title, Text1, Text2 } from '../../../ui/text'
import { ChevronLeft } from '../../../../assets/icons'
import theme from '../../../../styled/theme'
import useIsMobile from '../../../../hooks/useIsMobile'
import { ScreenContainer, NextButtonContainer, BackButton } from './styled'

const NecessityScreen = ({
	handleSubmit,
	info,
	historyIdHandler,
	hideBackButton,
	showExperienceTitle
}) => {
	const isMobile = useIsMobile()
	const [selectedAnswerId, setSelectedAnswerId] = useState(null)

	const handleNext = () => {
		const value = info.answers.find(answer => answer.id === selectedAnswerId)
		handleSubmit({ ...value, questionId: info.id, answerMode: info.answerMode })
	}

	return (
		<ScreenContainer>
			{!hideBackButton && (
				<BackButton onClick={() => historyIdHandler()}>
					<ChevronLeft
						size={16}
						color={isMobile ? theme.colors.text.secondaryText : theme.colors.brand.blueOmint}
					/>
					{!isMobile && <Text2 size="14px" color={theme.colors.brand.blueOmint}>Volver</Text2>}
				</BackButton>
			)}
			<Title
				as="h1"
				size="18px"
				mobileSize="18px"
				mobileAlign="center"
				color={theme.colors.text.primaryText}
			>
				{info?.description}
			</Title>
			<RadioButtonList
				options={info?.answers.map(answer => ({ id: answer.id, label: answer.description }))}
				selected={selectedAnswerId}
				onChange={setSelectedAnswerId}
				maxWidth="350px"
			/>
			<NextButtonContainer>
				<Button
					label={selectedAnswerId ? 'Enviar' : 'Siguiente'}
					$variant="primary"
					size="medium"
					disabled={!selectedAnswerId}
					onClick={handleNext}
				/>
			</NextButtonContainer>
		</ScreenContainer>
	)
}

export default NecessityScreen
